export default __webpack_public_path__ + "static/media/Tick.ba52b77a.svg";